// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_dyO","cls2":"CoScientistLandingPage-cls2_Eqw CoScientistLandingPage-cls1_dyO"};